import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 16);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 w-full transition-colors duration-300 ${
        scrolled || menuOpen
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="h-16 flex items-center justify-between gap-4">
          <a href="#top" className="flex items-center gap-2 shrink-0">
            <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-fire-line text-lg"></i>
            </span>
            <h1 className="font-heading text-lg md:text-xl font-bold tracking-wide text-foreground-950 whitespace-nowrap">
              黑料社区
            </h1>
          </a>

          <nav className="hidden md:flex items-center gap-1 lg:gap-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="px-3 py-2 rounded-md text-sm text-foreground-700 hover:text-primary-700 hover:bg-primary-50 transition-colors whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <div className="flex items-center gap-2 h-9 px-3 rounded-md border border-background-200 bg-background-100 w-56">
              <span className="w-4 h-4 flex items-center justify-center text-foreground-500">
                <i className="ri-search-line text-sm"></i>
              </span>
              <input
                type="text"
                placeholder="搜索话题 / 用户"
                aria-label="搜索话题或用户"
                className="w-full bg-transparent text-sm text-foreground-950 placeholder:text-foreground-500 focus:outline-none"
              />
            </div>
            <a
              href="#download"
              className="h-9 px-4 rounded-md bg-primary-500 text-background-50 text-sm font-medium inline-flex items-center gap-1.5 hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-login-circle-line"></i>
              进入社区
            </a>
          </div>

          <div className="flex items-center gap-2 md:hidden">
            <a
              href="#download"
              className="h-9 px-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium inline-flex items-center hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              进入
            </a>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setMenuOpen((v) => !v)}
              className="w-9 h-9 rounded-md border border-background-200 flex items-center justify-center text-foreground-800"
            >
              <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="md:hidden pb-4">
            <nav className="flex flex-col gap-1 border-t border-background-200 pt-3">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="flex items-center gap-2 px-3 py-2.5 rounded-md text-sm text-foreground-800 hover:bg-background-100 transition-colors"
                >
                  <span className="w-4 h-4 flex items-center justify-center text-foreground-600">
                    <i className={link.icon}></i>
                  </span>
                  {link.label}
                </a>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}